// extracted by mini-css-extract-plugin
export default {"walletBox":"styles_walletBox__kGu60"};